import { ButtonGhost, Text } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const CouponBase = {
  ActiveInputWrapper: styled('div')`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[4]};
  `,

  Container: styled.div`
    margin: 0 0 ${theme.space[4]};
    padding: 0 ${theme.space[4]};
  `,

  Text: styled(Text)`
    line-height: ${theme.space[1]};
  `,

  Button: styled(ButtonGhost)`
    min-width: 87px;
  `,

  CouponErrorWrapper: styled('div')`
    display: flex;
    align-items: flex-start;
  `,

  IconTextSuccessWrapper: styled('div')`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: ${theme.space[3]};
  `,

  SuccessfulWrapper: styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,

  ErrorIconWrapper: styled('div')`
    padding: ${theme.space[1]} ${theme.space[2]};
    path {
      fill: ${theme.colors.status.error.standard};
    }
  `,

  SuccessIconWrapper: styled('div')`
    path {
      fill: ${theme.colors.status.success.standard};
    }
  `,

  SuccessTextWrapper: styled('div')`
    display: flex;
    flex-direction: column;
  `,

  Wrapper: styled('div')`
    display: flex;
    align-items: center;
    gap: ${theme.space[2]};

    > div {
      flex: auto 1 1;
    }
  `,
};
